import { divide } from "lodash";
import React, { Component } from "react";
import { Divider } from "semantic-ui-react";
import { Segment, Button, Icon, Table, Select, Form, Tab, Message, Pagination, Input, Modal, Checkbox } from 'semantic-ui-react'
import config from "../config";
import  { invokeApig } from "../libs/awsLib";
import { JSONDate, lookupDescription, formatDateTime } from "../libs/sharedFunctions";
import ReactJson from 'react-json-view'
import { Link} from "react-router-dom";
import SmartOrchestration from "./SmartOrchestration";


const PAGE_SIZE=7;
const NO_PAGES=100;


export default class SmartDeviceOrchestrations extends Component {
  constructor(props) {
    super(props);
  
    const today=new Date();
    var startDate=new Date();
    startDate.setDate(today.getDate() - 1)
    var endDate=new Date();

    this.state = {
      orchestrations: [], 
      startDate: JSONDate(startDate), 
      endDate: JSONDate(endDate), 
      filterDeviceID: '', 
      filterCHFDeviceID: '', 
      filterMPXN: '', 
      filterOrchestration: 'installandcommission', 
      orchestrationStatus: [], 
      activePage: 1, 
      selectedOrchestration: null, 
      showViewOrchestration: false, 
      showAddOrchestration: false, 
      selectedOrchestration: {id: null}, 
      orchestrationHistory: [], 
      orchestrationDefinitions: {}, 
      orchestrationData: {}, 
      addSuccess: false, 
      addFailed: false, 
      addInProgress: false, 
      addErrors: []
    };
  

  
 }
 
loadOrchestrations=()=>
{

  var queryParams=['orchestration='+this.state.filterOrchestration];

  if (this.props.smartdevice.devicetype==='CHF')
    queryParams.push('chfdeviceeui='+this.props.smartdevice.deviceid)
  else
    queryParams.push('deviceeui='+this.props.smartdevice.deviceid)

  invokeApig({path: "/api/orchestrations", method: "GET", queryParams: queryParams}).then((result)=>
  {
    this.setState({orchestrations: result.data, selectedOrchestration: {id: null}, orchestrationHistory: []})
  });
}

loadOrchestrationHistory=()=>
{

  invokeApig({path: "/api/orchestrations/"+this.state.selectedOrchestration.id+'/orchestrationresponses', method: "GET"}).then((result)=>
  {
    this.setState({orchestrationHistory: result.data})
  });
}


loadOrchestrationStatus = () => {invokeApig({path: "/lookups/orchestrationstatus", method: "GET",  body: null}).then((result)=>{ this.setState({orchestrationStatus: result.data} )}).catch((err)=>{console.log(err)})}

loadOrchestrationDefinitions = () => {invokeApig({path: "/lookups/orchestrations", method: "GET",  body: null}).then((result)=>{ this.setState({orchestrationDefinitions: result.data} )}).catch((err)=>{console.log(err)})}

getOrchestrationData=(fieldName)=>{
  if (fieldName in this.state.orchestrationData)
    return this.state.orchestrationData[fieldName]
}

setOrchestrationData=(fieldName, value)=>{
  var newData=Object.assign({}, this.state.orchestrationData)
  newData[fieldName]=value;
  this.setState({orchestrationData: newData})
}

componentDidMount()
{
  this.loadOrchestrationStatus();
  this.loadOrchestrationDefinitions();
  this.loadOrchestrations();
}

addOrchestration=()=>{
  this.setState({addInProgress: true})
  var payload=Object.assign({}, this.state.orchestrationData);
  payload['source']="internal";
  invokeApig({path: "/orchestrations/"+this.state.filterOrchestration, method: "POST", body: payload}).then((result)=>
  {
    if (result.status===200)
    this.setState({addInProgress: false, addFailed: false, addSuccess: true, addErrors: []})
  else
  this.setState({addInProgress: false, addFailed: true, addSuccess: false, addErrors: result.data.failReasons})
  }).catch(err=>{this.setState({addInProgress: false, addFailed: true, addErrors: ['Unknown error']})});

}

validateOrchestration=()=>{
  var validData=true;
  Object.keys(this.state.orchestrationDefinitions[this.state.filterOrchestration].datarequirements).forEach(fieldName=>{
    const field=this.state.orchestrationDefinitions[this.state.filterOrchestration].datarequirements[fieldName];
    if (!field.nullable && !this.state.orchestrationData[fieldName])
    {
      validData=false
      console.log(fieldName, this.state.orchestrationData[fieldName])
    }
    
  })
  return validData

}

  render() {

      //handle pagination
      var activePage=this.state.activePage;
      var orchestrations=this.state.orchestrations;
      if (orchestrations.length<(activePage-1)*PAGE_SIZE)
      {
        activePage=1;
        this.setState({activePage: 1})
      }
      orchestrations=orchestrations.slice((activePage-1)*PAGE_SIZE, activePage*PAGE_SIZE)
      
      const orchestrationOptions=Object.keys(this.state.orchestrationDefinitions).map(orchestrationKey=>{return {key: orchestrationKey, value: orchestrationKey, text: this.state.orchestrationDefinitions[orchestrationKey].description }})

      const viewPanes = [
        { menuItem: {key: 'Data', content: 'Data', icon: 'table'}, render: () => 
        <Tab.Pane>
          <ReactJson src={this.state.selectedOrchestration.data} name={false} collapsed={false} iconStyle="triangle" displayDataTypes={false} displayObjectSize={false} />
      </Tab.Pane> }, 
      { menuItem: {key: 'History', content: 'History', icon: 'history'}, render: () => 
      <Tab.Pane>
        <Table>
        <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Date</Table.HeaderCell>
          <Table.HeaderCell>Step</Table.HeaderCell>
          <Table.HeaderCell>Description</Table.HeaderCell>
          <Table.HeaderCell>Status</Table.HeaderCell>
          <Table.HeaderCell>Data</Table.HeaderCell>
        </Table.Row>
        </Table.Header>
        <Table.Body>
        {this.state.orchestrationHistory.map(row=>{
          return <Table.Row>
            <Table.Cell>{formatDateTime(new Date(row.datetime))}</Table.Cell>
            <Table.Cell>{row.orchestrationstep}</Table.Cell>
            <Table.Cell>{"description" in row.responsedata ? row.responsedata.description : ''}</Table.Cell>
            <Table.Cell>{"status" in row.responsedata ? row.responsedata.status : ''}</Table.Cell>
            <Table.Cell>{<ReactJson src={row.responsedata} name={false} collapsed={true} iconStyle="triangle" displayDataTypes={false} displayObjectSize={false} />}</Table.Cell>
          </Table.Row>
        })}
        </Table.Body>
        </Table>
    </Tab.Pane> }]

    
    return <Segment className='devicedetail' >
      <Form>
        <Form.Group inline>
        <Form.Field><label style={{color: this.props.darkmode ? "white": "black"}}>Orchestration</label><Select options={orchestrationOptions} value={this.state.filterOrchestration} onChange={(event, data)=>{this.setState({filterOrchestration: data.value}); }} /></Form.Field>
        <Button className='seaglassbutton' disabled={!this.state.selectedOrchestration.id} onClick={()=>{this.loadOrchestrationHistory(); this.setState({showViewOrchestration: true})}}><Icon name='search'/>View</Button>
        <Button className='seaglassbutton' onClick={()=>{this.setState({showAddOrchestration: true, orchestrationData: {}, addSuccess: false, addFailed: false, addInProgress: false, addErrors: []})}}><Icon name='add'/>Add</Button>
        <Button className='seaglassbutton' onClick={()=>{this.loadOrchestrations()}}><Icon name='refresh'/>Refresh</Button>
        
        
        </Form.Group>
      </Form>
      <Table selectable compact>
        <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Id</Table.HeaderCell>
          <Table.HeaderCell>Date</Table.HeaderCell>
          <Table.HeaderCell>Orchestration</Table.HeaderCell>
          <Table.HeaderCell>Status</Table.HeaderCell>
          <Table.HeaderCell>Source</Table.HeaderCell>
        </Table.Row>
        </Table.Header>
        <Table.Body>
        {this.state.orchestrationDefinitions && orchestrations.map(orchestration=>{
          if (orchestration.orchestration in this.state.orchestrationDefinitions)
          return <Table.Row active={this.state.selectedOrchestration.id && orchestration.id===this.state.selectedOrchestration.id} onClick={(cell)=>{this.setState({selectedOrchestration: orchestration})}}>
            <Table.Cell>{orchestration.id}</Table.Cell>
            <Table.Cell>{formatDateTime(new Date(orchestration.datetime))}</Table.Cell>
            <Table.Cell>{this.state.orchestrationDefinitions[orchestration.orchestration].description}</Table.Cell>
            <Table.Cell>{lookupDescription(this.state.orchestrationStatus, orchestration.orchestrationstatus)}</Table.Cell>
            <Table.Cell>{orchestration.source}</Table.Cell>
            </Table.Row>
        })}
        </Table.Body>
        </Table>
        <Pagination activePage={this.state.activePage} totalPages={Math.ceil(this.state.orchestrations.length/PAGE_SIZE)} onPageChange={(event, { activePage })=>{this.setState({activePage: activePage})}}/> 
        <Modal open={this.state.showViewOrchestration} closeIcon onClose={()=>{this.setState({showViewOrchestration: false})}}>
          <Modal.Header>
            <h3><Icon circular className="seaglassblue" name="cogs"/>Orchestration Id: {this.state.selectedOrchestration.id}</h3>
          </Modal.Header>  
          <Modal.Content>
            <SmartOrchestration orchestrationid={this.state.selectedOrchestration.id} definition={this.state.orchestrationDefinitions[this.state.selectedOrchestration.orchestration]}/>
          </Modal.Content>
        </Modal>
        {(this.state.filterOrchestration in this.state.orchestrationDefinitions) && <Modal open={this.state.showAddOrchestration} closeOnDimmerClick={false} closeIcon onClose={()=>{this.setState({showAddOrchestration: false})}}>
          <Modal.Header>
            <h3><Icon circular className="seaglassblue" name="add"/>New Orchestration</h3>
          </Modal.Header>  
          <Modal.Content>
          <Form>
          {Object.keys(this.state.orchestrationDefinitions[this.state.filterOrchestration].datarequirements).filter(fieldName=>{return fieldName!='meterOperator'}).map(fieldName=>{
            const field=this.state.orchestrationDefinitions[this.state.filterOrchestration].datarequirements[fieldName];
            var fieldControl;
            if ('values' in field)
            fieldControl=<Select placeholder={fieldName} options={Object.keys(field.values).map(value=>{return {key: value, value: value, text: field.values[value]}})} value={this.getOrchestrationData(fieldName)} maxLength={field.length} onChange={(event, data)=>{this.setOrchestrationData(fieldName, data.value)}}/>
            else
            {
            if (field.type==='varchar')
            fieldControl=<Input placeholder={fieldName} value={this.getOrchestrationData(fieldName)} maxLength={field.length} onChange={(event, data)=>{this.setOrchestrationData(fieldName, data.value)}}/>
            else if (field.type==='decimal')
            fieldControl=<Input type='number' step={Math.pow(10, -field.scale)} placeholder={fieldName} value={this.getOrchestrationData(fieldName)} onChange={(event, data)=>{this.setOrchestrationData(fieldName, data.value)}}/>
            else if (field.type==='bit')
            fieldControl=<Checkbox placeholder={fieldName} value={this.getOrchestrationData(fieldName)} onChange={(event, data)=>{this.setOrchestrationData(fieldName, data.checked)}}/>
            }
            if (fieldControl)
              return <Form.Field required={!field.nullable}>
                <label>{fieldName}</label>
                {fieldControl}
              </Form.Field>
          })}
          </Form>
          {this.state.addSuccess && <Message
          success
          header="Orchestration successfully created"
        />}
        {this.state.addFailed && <Message
          error
          header="Orchestration creation failed"
          list={this.state.addErrors}
        />}
        <Divider/>
        <Button className="seaglassbutton" disabled={this.state.addSuccess || !this.validateOrchestration()} loading={this.state.addInProgress} onClick={()=>{this.addOrchestration()}}>Send</Button>
        <Button className="seaglassbutton" onClick={()=>{this.setState({showAddOrchestration: false})}}>Close</Button>          
          </Modal.Content>

        </Modal>}

      </Segment>

        }
}